
// Base column configuration
const baseOfflineOrderListColConfig = [
    {
        "label_of_column": "Order ID",
        "name_of_db_column": "orderId",
        "order_of_column": 1,
        "hideSortIcon": true,
    },
    {
        "label_of_column": "Order State",
        "name_of_db_column": "orderState",
        "order_of_column": 2,
        "hideSortIcon": true,
        "colorCode": true
    },
    {
        "label_of_column": "Order Type",
        "name_of_db_column": "orderType",
        "order_of_column": 3,
        "filterVariant": 'dropdown',
        "filterable": true,
        "hideSortIcon": true,
        "defaultFilterValue": "1P",
        "featureFlag": "showOrderTypeFeature", // Use feature flag instead of country code
        "dropdownOptions": [
            { id: "1P", displayText: "1P" },
            { id: "3P", displayText: "3P" }
        ]
    },
    {
        "label_of_column": "Store ID",
        "name_of_db_column": "storeId",
        "order_of_column": 4,
    },
    {
        "label_of_column": "Sold to customer Id",
        "name_of_db_column": "soldCustomerId",
        "order_of_column": 5,
    },
    {
        "label_of_column": "Date Updated",
        "name_of_db_column": "updatedDate",
        "order_of_column": 6,
        "filterVariant": 'date',
        "filterable": false,
    },
];

// Export the base configuration (unfiltered)
export const OfflineOrderListColConfig = baseOfflineOrderListColConfig;
  